exports.TRIAL_TYPE = 'cstrial-iglikes';